module.exports = __webpack_public_path__ + "media/images/categories/color/duplex-e4c15f45b4e76e7d84f12652294bc198.png";